module.exports = __webpack_public_path__ + "static/media/logo.a359aa21.svg";